/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCardDetails} from '../api'

 export const useQueryGetCardDetails = createReactQueryHook('getCardDetails', getCardDetails)
